<template>
  <div :class="mobile.toLowerCase()">
    <q-input :ref="_uid" :clearable="clearable" :readonly="readonly" v-model="value" :label="placeholder" type="text" aria-label="vue-hotel-datepicker-input"
    :error-message="errors.first(`${scaffolding.vvScope}.${scaffolding.fieldName}`)"
    data-vv-validate-on="blur|submitEvent"
    v-validate="scaffolding.validation"
    :name="scaffolding.fieldName"
    :error="errors.has(`${scaffolding.vvScope}.${scaffolding.fieldName}`)"
      @click="active = !active" bottom-slots>
      <template v-slot:prepend>
        <q-icon :name="icon" />
      </template>
      <template v-slot:append>
        <q-icon @click="active = !active" name="event">
          <q-dialog v-model="active">
            <div class="vhd-picker" :class="{ 'text-center vhd-scroll' : $q.screen.xs }" style="max-width: 100vw">
              <div class="vhd-calendar">
                <div class="vhd-calendar-header" :class="{ 'q-mb-md': $q.screen.xs }">
                  <a class="close" @click="close">
                    <IconClose />
                  </a>
                  <div class="row justify-between">
                    <span class="info col-7 col-sm-4 self-center">
                      <span v-if="mode === 'range' && selectStartDate" class="from-text">{{ fromText }}</span>
                      <span v-if="selectStartDate" class="from-date"><b> {{ displayDateText(selectStartDate) }} </b></span>
                      <span v-if="mode === 'range' && selectEndDate" class="to-text">{{ toText }}</span>
                      <span v-if="mode === 'range' && selectEndDate" class="from-date"> <b> {{ displayDateText(selectEndDate) }}</b> </span>
                    </span>
                    <div class="q-mr-xl">
                      <q-radio v-model="mode" val="day" label="Ngày" />
                      <q-radio v-model="mode" val="range" label="Khoảng thời gian" />
                    </div>
                  </div>
                </div>
                <div class="vhd-calendar-left">
                  <div class="calendar-month">
                    <a :class="disabledPreviousArrow(startMonthDate)" class="previous-arrow offset-2"
                      @click="updateCalendar(-2)">
                      <IconArrowBack class="arrow" />
                    </a>
                    <a :class="disabledPreviousArrow(startMonthDate)" class="previous-arrow offset-1"
                      @click="updateCalendar(-1)">
                      <IconArrowBack class="arrow" />
                    </a>
                    <div class="calendar-month-title">
                      {{ monthList[startMonthDate.getMonth()] }} {{ startMonthDate.getFullYear() }}
                    </div>
                    <a class="next-arrow offset-1" @click="updateCalendar(1)">
                      <IconArrowForward class="arrow" />
                    </a>
                  </div>
                  <div class="calendar-week">
                    <div v-for="(wItem, index) in weekList" :key="index" class="calendar-week-item">
                      {{ wItem }}
                    </div>
                  </div>
                  <div class="calendar-date">
                    <div v-for="(week, wIndex) in startMonthAry" :key="wIndex" class="week">
                      <div v-for="(startDay, dIndex) in week" :key="dIndex" :class="dayStatus(startDay)" class="day"
                        @click="dayOnClick(startDay)">
                        <span v-if="startDay">
                          {{ startDay.getDate() }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vhd-calendar-right">
                  <div class="calendar-month">
                    <a class="next-arrow" @click="updateCalendar(2)">
                      <IconArrowForward class="arrow" />
                    </a>
                    <div class="calendar-month-title">
                      {{ monthList[endMonthDate.getMonth()] }} {{ endMonthDate.getFullYear() }}
                    </div>
                  </div>
                  <div class="calendar-week">
                    <div v-for="(wItem, index) in weekList" :key="index" class="calendar-week-item">
                      {{ wItem }}
                    </div>
                  </div>
                  <div class="calendar-date">
                    <div v-for="(week, wIndex) in endMonthAry" :key="wIndex" class="week">
                      <div v-for="(endDay, dIndex) in week" :key="dIndex" :class="dayStatus(endDay)" class="day"
                        @click="dayOnClick(endDay)">
                        <span v-if="endDay">
                          {{ endDay.getDate() }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vhd-calendar-footer q-mt-md">
                  <q-btn flat v-if="selectStartDate || selectEndDate" :label="resetText" class="reset" @click="reset"></q-btn>
                  <q-btn flat v-if="selectStartDate && selectEndDate" :label="confirmText" class="confirm" @click="confirm"></q-btn>
                </div>
              </div>
            </div>
          </q-dialog>
        </q-icon>
      </template>
    </q-input>
  </div>
</template>
<script>
import IconClose from './icon/IconClose'
import IconArrowBack from './icon/IconArrowBack'
import IconArrowForward from './icon/IconArrowForward'
export default {
  name: 'VueRangeDatepicker',
  components: {
    IconClose,
    IconArrowBack,
    IconArrowForward
  },
  directives: {},
  props: {
    placeholder: {
      type: String,
      default: 'Select a date range'
    },
    icon: {
      type: String,
      default: 'access_time'
    },
    seperator: {
      type: String,
      default: '~'
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY'
    },
    startDate: {
      type: [String, Date],
      default: undefined
    },
    endDate: {
      type: [String, Date],
      default: undefined
    },
    minDate: {
      type: [String, Date],
      default: () => new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0)
    },
    maxDate: {
      type: [String, Date, Boolean],
      default: false
    },
    minNight: {
      type: Number,
      default: undefined
    },
    maxNight: {
      type: Number,
      default: undefined
    },
    selectForward: {
      type: Boolean,
      default: true
    },
    disabledDates: {
      type: Array,
      default: () => []
    },
    weekList: {
      type: Array,
      default: () => ['Sun.', 'Mon.', 'Tue.', 'Wen.', 'Thu.', 'Fri.', 'Sat.']
    },
    monthList: {
      type: Array,
      default: () => ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct', 'Nov.', 'Dec.']
    },
    fromText: {
      type: String,
      default: 'Từ'
    },
    toText: {
      type: String,
      default: 'đến'
    },
    resetText: {
      type: String,
      default: 'Chọn lại'
    },
    confirmText: {
      type: String,
      default: 'Xác nhận'
    },
    mobile: {
      type: String,
      default: '' // mobile or desktop
    },
    modelProps: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    scaffolding: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      value: this.modelProps,
      active: false,
      startMonthDate: undefined,
      endMonthDate: undefined,
      selectStartDate: undefined,
      selectEndDate: undefined,
      selectMinDate: undefined,
      selectMaxDate: undefined,
      startMonthAry: [],
      endMonthAry: [],
      clickCount: 0,
      mode: 'range'
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  computed: {},
  watch: {
    mode () {
      this.reset()
    },
    active (newValue) {
      if (!newValue) this.validate()
    }
  },
  created () {
    if (this.startDate && this.endDate) {
      const startDateValue = typeof (this.startDate) === 'string' ? this.startDate : this.startDate.getTime()
      this.selectStartDate = new Date(startDateValue)
      const endDateValue = typeof (this.endDate) === 'string' ? this.endDate : this.endDate.getTime()
      this.selectEndDate = new Date(endDateValue)
      this.updateValue()
    }
    if (this.minDate) {
      const minDateValue = typeof (this.minDate) === 'string' ? this.minDate : this.minDate.getTime()
      this.selectMinDate = new Date(minDateValue)
    }
    if (this.maxDate) {
      const maxDateValue = typeof (this.maxDate) === 'string' ? this.maxDate : this.maxDate.getTime()
      this.selectMaxDate = new Date(maxDateValue)
    }
    this.updateCalendar() // after setting
  },
  mounted () {},
  methods: {
    close () {
      this.active = false
      this.$emit('close')
    },
    reset () {
      this.selectStartDate = undefined
      this.selectEndDate = undefined
      this.value = ''
      this.$emit('reset')
    },
    confirm () {
      if (this.selectStartDate && !this.selectEndDate) {
        this.selectEndDate = new Date(this.selectStartDate.getTime())
        this.selectEndDate.setDate(this.selectStartDate.getDate() + 1)
        this.updateValue()
      }
      if (this.selectStartDate && this.selectEndDate) {
        const dateResult = {
          start: this.displayDateText(this.selectStartDate),
          end: this.displayDateText(this.selectEndDate)
        }
        this.$emit('comform', dateResult)
        this.active = false
      }
    },
    displayDateText (datetime) {
      if (datetime) {
        datetime = typeof (datetime) === 'string' ? new Date(datetime) : datetime
        const yyyy = datetime.getFullYear()
        const mm = datetime.getMonth() + 1 > 9 ? datetime.getMonth() + 1 : `0${datetime.getMonth() + 1}`
        const dd = datetime.getDate() > 9 ? datetime.getDate() : `0${datetime.getDate()}`
        const displayStr = (this.format || 'YYYY/MM/DD').replace('YYYY', yyyy).replace('MM', mm).replace('DD', dd)
        return displayStr
      } else {
        return undefined
      }
    },
    generateCalendar (calculateYear = new Date().getFullYear(), calculateMonth = new Date().getMonth(), config = {}) {
      const showPreviousMonthDate = config.showPreviousMonthDate || false
      const showNextMonthDate = config.showNextMonthDate || false
      const baseDateTime = new Date(calculateYear, calculateMonth, 1, 0, 0, 0)
      let countTime = new Date(calculateYear, calculateMonth, 1, 0, 0, 0)
      let tempMonthAry = []
      let tempWeekAry = []
      let nextMonth = false
      let completed = false
      while (!nextMonth || (nextMonth && !completed)) {
        let day = countTime.getDay()
        let date = countTime.getDate()
        let month = countTime.getMonth()
        // check next month
        if (month !== calculateMonth) {
          nextMonth = true
          if (day === 6 || (date === 1 && day === 0)) {
            completed = true
          }
        }
        // Set date
        if (!nextMonth) {
          tempWeekAry[day] = new Date(countTime.getTime()) // date obj
        } else {
          tempWeekAry[day] = showNextMonthDate ? new Date(countTime.getTime()) : false
        }
        // check previous
        if (countTime.getTime() === baseDateTime.getTime() && day !== 0) {
          // Fill previous
          let previousDay = day
          let previousCountTime = new Date(countTime.getTime())
          previousCountTime.setDate(previousCountTime.getDate())
          if (showPreviousMonthDate) {
            while (previousDay !== 0) {
              // let previousDate = previousDateTime.getDate()
              let previousDateTime = new Date(previousCountTime.getTime())
              previousDay = previousDateTime.getDay()
              tempWeekAry[previousDay] = previousDateTime // date obj
              previousCountTime.setDate(previousCountTime.getDate() - 1)
            }
          }
        }
        // check new week
        if ((countTime.getTime() === baseDateTime.getTime() && tempWeekAry.length === 7) ||
            (countTime.getTime() > baseDateTime && day === 6)) {
          // Next week
          tempMonthAry.push(tempWeekAry)
          tempWeekAry = []
        }
        // calculate next day
        countTime.setDate(countTime.getDate() + 1)
      }

      return tempMonthAry
    },
    updateCalendar (offset = 0) {
      if (!this.startMonthDate) {
        this.startMonthDate = this.selectStartDate
          ? this.selectStartDate
          : new Date(new Date().getFullYear(), new Date().getMonth()) // now
      }

      this.startMonthDate.setMonth(this.startMonthDate.getMonth() + offset)
      this.endMonthDate = new Date(this.startMonthDate.getFullYear(), this.startMonthDate.getMonth() + 1)

      this.startMonthAry = []
      this.endMonthAry = []
      this.startMonthAry = this.generateCalendar(this.startMonthDate.getFullYear(), this.startMonthDate.getMonth())
      this.endMonthAry = this.generateCalendar(this.endMonthDate.getFullYear(), this.endMonthDate.getMonth())
    },
    updateValue () {
      this.value = this.mode === 'range' ? `${this.displayDateText(this.selectStartDate)} ${this.seperator} ${this.displayDateText(this.selectEndDate)}` : this.displayDateText(this.selectStartDate)
      this.$emit('input', this.value)
    },
    disabledPreviousArrow (datetime) {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
      if (datetime &&
          datetime.getFullYear() === today.getFullYear() &&
          datetime.getMonth() === today.getMonth() &&
          this.selectForward) {
        return 'disabled'
      }
    },
    dayStatus (datetime) {
      const classList = []
      if (datetime) {
        const now = new Date()
        // const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
        // check status
        if (this.selectMinDate.getTime() > datetime.getTime()) {
          classList.push('disabled')
        } else if (this.selectMaxDate && this.selectMaxDate.getTime() < datetime.getTime()) {
          classList.push('disabled')
        } else if (this.disabledDates.indexOf(this.displayDateText(datetime)) > -1) {
          classList.push('disabled')
          classList.push('forbidden')
        } else if (this.selectStartDate && this.selectStartDate.getTime() > datetime.getTime() && !this.selectForward) {
          classList.push('disabled')
        } else if (this.selectStartDate && this.selectStartDate.getTime() === datetime.getTime()) {
          classList.push('start-date')
        } else if (this.selectEndDate && this.selectEndDate.getTime() === datetime.getTime()) {
          classList.push('end-date')
        } else if (this.selectStartDate && this.selectEndDate &&
                   datetime.getTime() > this.selectStartDate.getTime() &&
                   datetime.getTime() < this.selectEndDate.getTime()) {
          classList.push('in-date-range')
        }
        // check min night and max night
        if (this.selectStartDate && this.selectStartDate.getTime() < datetime.getTime() &&
            ((Number.isInteger(this.minNight) && this.minNight > 0) || (Number.isInteger(this.maxNight) && this.maxNight > 0))) {
          const night = (datetime.getTime() - this.selectStartDate.getTime()) / (1000 * 60 * 60 * 24)
          if (night < this.minNight) {
            classList.push('disabled')
          } else if (night > this.maxNight) {
            classList.push('disabled')
          }
        }
        // check today
        if (now.getFullYear() === datetime.getFullYear() &&
            now.getMonth() === datetime.getMonth() &&
            now.getDate() === datetime.getDate()
        ) {
          classList.push('today')
        }
      }
      return classList
    },
    dayOnClick (datetime) {
      if (datetime) {
        if (this.mode === 'range') {
          if (!this.selectStartDate) {
            this.selectStartDate = datetime
          } else if (!this.selectEndDate) {
            if (this.selectStartDate && datetime.getTime() < this.selectStartDate.getTime()) {
              this.selectEndDate = this.selectStartDate
              this.selectStartDate = datetime
            } else {
              this.selectEndDate = datetime
            }
          } else if (datetime.getTime() < this.selectStartDate.getTime()) {
            this.selectStartDate = datetime
          } else if (datetime.getTime() > this.selectEndDate.getTime()) {
            this.selectEndDate = datetime
          } else if (datetime.getTime() > this.selectStartDate.getTime() &&
                    datetime.getTime() < this.selectEndDate.getTime()) {
            if (this.clickCount % 2 === 0) {
              this.selectStartDate = datetime
            } else {
              this.selectEndDate = datetime
            }
            this.clickCount++
          }
          const dateResult = {
            start: this.displayDateText(this.selectStartDate),
            end: this.displayDateText(this.selectEndDate)
          }
          this.$emit('update', dateResult)
        } else {
          this.selectStartDate = datetime
        }
        if (this.mode === 'day') {
          this.selectEndDate = this.selectStartDate
        }
        if (this.selectStartDate && this.selectEndDate) {
          this.updateValue()
        }
      }
    },
    validate () {
      this.$refs[this._uid].$emit('submitEvent', this.value)
    }
  }
}
</script>
<style lang="scss" scoped src="./style.scss"></style>
